import { render, staticRenderFns } from "./zhenci-msg.vue?vue&type=template&id=66bd0a23&scoped=true&"
import script from "./zhenci-msg.vue?vue&type=script&lang=ts&"
export * from "./zhenci-msg.vue?vue&type=script&lang=ts&"
import style0 from "./zhenci-msg.vue?vue&type=style&index=0&id=66bd0a23&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66bd0a23",
  null
  
)

export default component.exports